import { Route } from "react-router-dom"
import TruckIncomeSummary from "./TruckIncomSummary/TruckIncomeSummary"
import JobOrderAllDetail from "./ContainerAllDetail/JobOrderAllDetail"
import JobOrderExpense from "./JobOrderExpense/JobOrderExpense"
import DriverSalary from "./DriverSalary/DriverSalary"
import FuelReportPeriod from "./FuelReportPeriod/FuelReportPeriod"
import MonthlyTruckReport from "./MonthlyTruckReport/MonthlyTruckReport"
import DailyDriverStatus from "./DaillyDriverStatus/DailyDriverStatus"
import MonthlyCustomerReport from "./MonthlyCustomerReport/MonthlyCustomerReport"
// import ShippingProcessLIT from "./ShippingProcess/ShippingProcessLIT"
import DriverExpress from "./DriverExpress/DriverExpress"
import BillingNoteManagement365 from "./BillingNoteManagement365/BillingNoteManagement365"
import ShippingProcessImport from "./ShippingProcess/ShippingProcessImport"


// export const branchApiNm = {
//   getJobOrderAllDetail: "/branch/getJobOrderAllDetail",
//   getFinJobOrder: "/branch/getFinJobOrder",
//   getInvoice: "/branch/getInvoice",
//   getPrintInvoiceConfig: "/branch/getPrintInvoiceConfig",
//   insertPrintInvoiceConfig: "/branch/insertPrintInvoiceConfig",
//   deletePrintInvoiceConfig: "/branch/deletePrintInvoiceConfig"
// }
export const extraPageName = {
  ShippingProcessLIT: "Shipping Process",
  ShippingProcessImport: "Shipping Process (Import)",
  ShippingProcessExport: "Shipping Process (Export)",
  JobPlaning: "การวางแผนงาน",
  TruckIncomeSummary: "รายงานรายได้แยกตามรถ",
  JobOrderAllDetail: "รายละเอียดงานและค่าใช้จ่าย",
  JobOrderExpense: "ค่าใช้จ่ายงาน",
  DriverSalary: "เงินเดือนพนักงานขับรถ",
  FuelReportPeriod: "รายงานการใช้น้ำมัน",
  MonthlyTruckReport: "รายงานรายได้รถประจำเดือน",
  MonthlyCustomerReport: "รายงานลูกค้าประจำเดือน",
  DailyDriverStatus: "รายงาน พขร.-งาน ประจำวัน",
  DriverExpress: "บัญชี พขร. Express",
  BillingNoteManagement365: "วางบิล 365",
}
export const extraPageMenu = [
  // { page: "JobPlaning", num: "8.1", menuName: extraPageName.JobPlaning, prNum: 8 },
  // { page: "ShippingProcessLIT", num: "8.1", menuName: extraPageName.ShippingProcessLIT, prNum: 8 },
  { page: "ShippingProcessExport", num: "8.1.1", menuName: extraPageName.ShippingProcessExport, prNum: 8 },
  { page: "ShippingProcessImport", num: "8.1.2", menuName: extraPageName.ShippingProcessImport, prNum: 8 },
  { page: "TruckIncomeSummary", num: "8.2", menuName: extraPageName.TruckIncomeSummary, prNum: 8, permission: "EXE;FIN"},
  { page: "JobOrderAllDetail", num: "8.3", menuName: extraPageName.JobOrderAllDetail, prNum: 8, permission: "EXE;FIN"},
  { page: "JobOrderExpense", num: "8.4", menuName: extraPageName.JobOrderExpense, prNum: 8, permission: "EXE;FIN"},
  { page: "DriverSalary", num: "8.5", menuName: extraPageName.DriverSalary, prNum: 8, permission: "EXE;FIN"},
  { page: "FuelReportPeriod", num: "8.6", menuName: extraPageName.FuelReportPeriod, prNum: 8},
  { page: "MonthlyTruckReport", num: "8.7", menuName: extraPageName.MonthlyTruckReport, prNum: 8},
  { page: "MonthlyCustomerReport", num: "8.8", menuName: extraPageName.MonthlyCustomerReport, prNum: 8},
  { page: "DailyDriverStatus", num: "8.9", menuName: extraPageName.DailyDriverStatus, prNum: 8},
  { page: "DriverExpress", num: "8.10", menuName: extraPageName.DriverExpress, prNum: 8, permission: "FIN"},
  { page: "BillingNoteManagement365", num: "8.11", menuName: extraPageName.BillingNoteManagement365, prNum: 8, permission: "FIN"},
]

export const extraRoute = (path)=> [
  // <Route key="JobPlaning" path={`${path}/JobPlaning`} ><JobPlanning /> </Route>,
  // <Route key={"ShippingProcessLIT"} path={`${path}/ShippingProcessLIT`} ><ShippingProcessLIT /> </Route>,
  <Route key={"ShippingProcessExport"} path={`${path}/ShippingProcessExport`} ><ShippingProcessImport mode="EX"/> </Route>,
  <Route key={"ShippingProcessImport"} path={`${path}/ShippingProcessImport`} ><ShippingProcessImport mode="IM"/> </Route>,
  <Route key={"TruckIncomeSummary"} path={`${path}/TruckIncomeSummary`} ><TruckIncomeSummary /> </Route>,
  <Route key={"JobOrderallDetail"} path={`${path}/JobOrderAllDetail`} ><JobOrderAllDetail /> </Route>,
  <Route key={"JobOrderExpense"} path={`${path}/JobOrderExpense`} ><JobOrderExpense /> </Route>,
  <Route key={"DriverSalary"} path={`${path}/DriverSalary`} ><DriverSalary /> </Route>,
  <Route key={"FuelReportPeriod"} path={`${path}/FuelReportPeriod`} ><FuelReportPeriod /> </Route>,
  <Route key={"MonthlyTruckReport"} path={`${path}/MonthlyTruckReport`} ><MonthlyTruckReport /> </Route>,
  <Route key={"MonthlyCustomerReport"} path={`${path}/MonthlyCustomerReport`} ><MonthlyCustomerReport /> </Route>,
  <Route key={"DailyDriverStatus"} path={`${path}/DailyDriverStatus`} ><DailyDriverStatus /> </Route>,
  <Route key={"DriverExpress"} path={`${path}/DriverExpress`} ><DriverExpress /> </Route>,
  <Route key={"BillingNoteManagement365"} path={`${path}/BillingNoteManagement365`} ><BillingNoteManagement365 /> </Route>,

]
